// Khoá bộ nhớ đệm của màn Chat khách — một chỗ cho mọi khối (danh sách, khung
// hội thoại, ô soạn, hộp câu mẫu, hộp giờ làm việc) cùng đọc và cùng làm mới.
import type { ChatListFilters } from "./api";

export const SESSIONS_KEY = ["customer-chats", "sessions"] as const;
/** Mỗi bộ lọc một khoá — đổi lọc là đổi khoá, không trộn hai danh sách. */
export const sessionsKey = (filters: ChatListFilters) =>
  [
    ...SESSIONS_KEY,
    filters.tab,
    filters.status,
    filters.unanswered ? "unanswered" : "-",
    filters.mentions ? "mentions" : "-",
    filters.newCustomer ? "new-customer" : "-",
    filters.turn ?? "-",
    filters.tag ?? "all",
  ] as const;
export const TAGS_KEY = ["customer-chats", "tags"] as const;
export const ME_KEY = ["customer-chats", "me"] as const;
export const CANNED_KEY = ["customer-chats", "canned"] as const;
export const BUSINESS_HOURS_KEY = ["customer-chats", "business-hours"] as const;
export const CHAT_APPEARANCE_KEY = ["customer-chats", "appearance"] as const;
export const messagesKey = (sessionId: string) => ["customer-chats", "messages", sessionId] as const;
/** Khách của một luồng mở bằng đường dẫn (?thread=) mà không nằm trong danh sách đang lọc. */
export const threadCustomerKey = (sessionId: string) => ["customer-chats", "thread-customer", sessionId] as const;
/** Con số trên mục "Chat khách" của menu — đứng NGOÀI SESSIONS_KEY vì các lượt vá danh sách ghi thẳng vào mọi khoá dưới đó. */
export const WAITING_COUNT_KEY = ["customer-chats", "waiting-count"] as const;
export const customerOrdersKey = (sessionId: string) => ["customer-chats", "customer-orders", sessionId] as const;
export const assignableKey = (sessionId: string) => ["customer-chats", "assignable", sessionId] as const;
export const PARTNER_SESSIONS_KEY = ["customer-chats", "partner-sessions"] as const;
export const partnerMessagesKey = (sessionId: string) => ["customer-chats", "partner-messages", sessionId] as const;
